import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Home from '../pages/Home/Home'; //个人中心
import Login from '../pages/Account/LoginNew'; //登录页

import Profile from '../pages/Personal/Profile'; //个人资料页

import InviteHome from '../pages/InviteTeam/InviteHome'; //邀请业务员/团队
import InviteLogin from '../pages/InviteTeam/InviteLoginNew'; //注册创业合伙人
import ApplyResult from '../pages/InviteTeam/ApplyResult';  //申请结果页
import InviteShareList from '../pages/InviteTeam/InviteShareList'; // 邀请分享记录

import GroupHome from '../pages/Group/GroupHome'; //我的团队
import GroupDetail from '../pages/Group/GroupDetail'; //团队详情
import TeamHome from '../pages/Group/TeamHome'; //队员详情

import CustomHome from '../pages/Custom/CustomHome'; //我的客户
import CustomList from '../pages/Custom/CustomList'; //客户列表
import CustomDetail from '../pages/Custom/CustomDetail'; //客户详情

import IncomeHome from '../pages/Income/IncomeHome'; //我的收益
import IncomeDetail from '../pages/Income/IncomeDetail'; //收益明细

import WalletHome from '../pages/Wallet/WalletHome'; //钱包
import Withdraw from '../pages/Wallet/Withdraw'; //提现
import BindCard from '../pages/Wallet/BindCard'; //提现
import TaxRule from '../pages/Wallet/TaxRule'; //扣税规则
import WithdrawRes from '../pages/Wallet/WithdrawRes'; //提现
import Password from '../pages/Wallet/Password'; //提现
import SupportBank from '../pages/Wallet/SupportBank'; //提现
import IDCard from '../pages/IDCard/IDCard';

import NoticeHome from '../pages/Notice/NoticeHome'; //消息
import NoticeDetail from '../pages/Notice/NoticeDetail'; //消息详情

import SpreadAssist from '../pages/Activity/SpreadAssist'; //推广助手

class RouteConfig extends Component {
  render () {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path='/' component={Home}/>
          <Route exact path='/login' component={Login}/>

          <Route exact path='/profile' component={Profile}/>

          <Route exact path='/inviteHome/:type' component={InviteHome}/>
          <Route exact path='/inviteLogin' component={InviteLogin}/>
          <Route exact path='/applyResult' component={ApplyResult}/>
          <Route exact path='/InviteShareList' component={InviteShareList}/>

          <Route exact path='/groupHome' component={GroupHome}/>
          <Route exact path='/groupDetail' component={GroupDetail}/>
          <Route exact path='/teamHome/:id' component={TeamHome}/>

          <Route exact path='/customHome' component={CustomHome}/>
          <Route exact path='/customList' component={CustomList}/>
          <Route exact path='/customDetail/:id' component={CustomDetail}/>

          <Route exact path='/incomeHome' component={IncomeHome}/>
          <Route exact path='/incomeDetail' component={IncomeDetail}/>

          <Route exact path='/walletHome' component={WalletHome}/>
          <Route exact path='/withdraw' component={Withdraw}/>
          <Route exact path='/bindCard' component={BindCard}/>
          <Route exact path='/taxRule' component={TaxRule}/>
          <Route exact path='/withdrawRes' component={WithdrawRes}/>
          <Route exact path='/password' component={Password}/>
          <Route exact path='/supportBank' component={SupportBank}/>
          <Route exact path='/idCard' component={IDCard}/>

          <Route exact path='/noticeHome' component={NoticeHome}/>
          <Route exact path='/noticeDetail/:id' component={NoticeDetail}/>

          <Route exact path='/spreadAssist/:type' component={SpreadAssist}/>
        </Switch>
      </BrowserRouter>
    )
  }
}

export default RouteConfig;
